import React, {Component} from 'react';
import styled from 'styled-components';
import InputBlock from "./DeliveryPage";
import {mixins} from "../../mixins";

const Column = styled.div`
  
`;

const Header = styled.div`
   margin-bottom: 20px;
   position: relative;
   padding-top: 0.3em;
   padding-bottom: 0.3em;
   &:after{
    ${mixins.pseudoToBlock()};
    position: absolute;
    height: 1px;
    width: auto;
    bottom: 0;
    left: -15px;
    right: -15px;
    background-color: ${p => p.theme.cBorder};
   }
`;

const Content = styled.div`
  
`;

class CartColumn extends Component {
    render() {
        return (
            <Column className={'cartColumn'}>
                <Header className={'cartColumn__header'}>
                    {this.props.title}
                </Header>
                <Content>
                    {this.props.children}
                </Content>
            </Column>
        );
    }
}

export default CartColumn